import downloadData  from './Download';
const DownloadCSV = ({ data, fileName }) => {
  const convertToCSV = (objArray) => {
    
    const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    const properties = Object.getOwnPropertyNames(array[0]);
    for (let j = 0; j < properties.length; j++) {
      if (properties[j] === "__typename") {
        continue;
      }
      str += properties[j] + ",";
    }
    str += '\r\n';
    for (let i = 0; i < array.length; i++) {
      let line = '';      
      for (let index in array[i]) {
        if(index=="__typename") continue;
        if (line !== '') line += ',';

        line += array[i][index];
      }
      str += line + '\r\n';
    }
    return str;
  };
  downloadData({data:convertToCSV(data),fileName:fileName,extension:"csv"})  
}

export default DownloadCSV;